<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {isSavingCurrentStep} from "@/composables/ai-onboarding/useSteps";
import {computed} from "vue";

const props = defineProps({
  disableContinue: {
    type: Boolean,
    required: false,
    default: false,
  },
  showBackButton: {
    type: Boolean,
    required: false,
    default: true,
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emit = defineEmits(['next', 'back']);

const isLoading = computed(() => props.loading || isSavingCurrentStep.value);
</script>

<template>
  <div class="tw-flex tw-justify-between tw-w-full tw-border-t-2 tw-border-grey-mid tw-py-8 tw-px-16">
    <DefaultButton
      v-if="showBackButton"
      :disabled="isLoading"
      variant="primary-inverted"
      @click="emit('back')"
    >
      <svg-vue
        icon="icons/arrow-right"
        class="tw-w-6 tw-h-6 tw-mr-2 tw-rotate-180"
      />
      Back
    </DefaultButton>

    <DefaultButton
      :disabled="disableContinue || isLoading"
      class="tw-w-56 ml-auto tw-py-4"
      @click="emit('next')"
    >
      <div class="tw-flex tw-gap-4 tw-items-center">
        <svg-vue
          v-if="isLoading"
          icon="icons/loading"
          class="tw-w-6 tw-h-6"
        />
        <span>
          Continue
        </span>
      </div>
    </DefaultButton>
  </div>
</template>
